import React, {forwardRef} from 'react';
import {CSSTransition} from 'react-transition-group';
import {useContentWrapperContext} from '../ContentWrapper';

export const Toolbar = forwardRef(<T extends HTMLElement>({ children }: React.PropsWithChildren, ref: React.Ref<T>) => {
  const { isControlVisible } = useContentWrapperContext();

  return (
    <CSSTransition nodeRef={ref} timeout={400} classNames="slide-from-bottom" in={isControlVisible}>
      {children}
    </CSSTransition>
  );
});
